<template>
  <div class="pageContent">
    <div class="filmQueryLoading" v-if="filmQueryLoading">
      <van-loading class="vanLoading" color="#1989fa" />
    </div>
    <hospitals :hospitalsInfo="hospitalsInfo" />
    <hospitalsCon v-if="hospitalsInfo.search!=''&&hospitalsInfo.search!='name'" :hospitalsInfo="hospitalsInfo" :placeholder="placeholder" @getReportInfo="getReportInfo" @getscan="getscan" />
    <hospitalsNmae v-else-if="hospitalsInfo.search!=''&&hospitalsInfo.search=='name'" @getFuzzyReportInfo="getFuzzyReportInfo" :hospitalsInfo="hospitalsInfo" />
    <!-- <div class="perfectData" @click="checkInf">
      <img src="@/assets/data.png" alt />
      <p style="color:#13acc1">完善资料</p>
    </div> -->
    <div class="perfectData" style="left: 85%" @click="logoutFn">
      <img src="@/assets/tuichu.png" alt />
      <p style="color:#13acc1">注销</p>
    </div>
  </div>
</template>
<script>
import hospitals from '@/components/filmQuery/index.vue'
import hospitalsCon from '@/components/filmQuery/sweepCode.vue'
import hospitalsNmae from '@/components/filmQuery/inquireName.vue'
import wx from 'weixin-js-sdk'
import axios from 'axios'
import { Dialog, Notify } from 'vant'
import {
  institutionLocation,
  getInsName,
  fuzzyReportInfo,
  getReportByBarCode
} from '@/api/check'
import { reportInfo } from '@/api/report'
import { logout } from '@/api/login'
import Storage from '@/tools/storage'
export default {
  name: 'filmQuery',
  components: { hospitals, hospitalsCon, hospitalsNmae },
  data() {
    return {
      params: {
        longitude: 104.28719112472622,
        latitude: 30.575407427453005
      },
      allowed: '',
      hospitalsInfo: {
        name: '',
        id: '',
        search: '',
        is_bar_code: 1
      },
      bar_code: '',
      placeholder: '',
      filmQueryLoading: true
    }
  },
  methods: {
    /**获取地图定位*/
    async wxSDK() {
      /* wx.authorize()*/

      axios
        .post('https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig')
        .then(res => {
          const that = this
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['getLocation', 'openLocation']
          })
          wx.ready(function () {
            wx.getLocation({
              type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                let latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                let longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                let speed = res.speed // 速度，以米/每秒计
                let accuracy = res.accuracy // 位置精度
                that.params = {
                  longitude: res.longitude,
                  latitude: res.latitude
                }
                Storage.set('Location', that.params)
                that.getInstitutionLocation()
                that.getInsName(this.hospitalsInfo.id)
                // if (this.hospitalsInfo.id) {
                //   that.getInsName(this.hospitalsInfo.id)
                // } else {
                //   that.getInsName('')
                // }
              },
              cancel: function (err) {
                // 这里走不允许的流程
                if (Storage.get('id')) {
                  that.getInsName()
                } else {
                  alert('位置定位失败,请先选择就诊医院')
                  that.$router.push({
                    path: '/findHospital',
                    query: { LocationFail: true }
                  })
                }
                that.getInsName('')
              }
            })
          })

          that.filmQueryLoading = false
        })
    },
    async getscan() {
      const that = this
      axios
        .post('https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig')
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['scanQRCode']
          })
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              ; (that.bar_code = res.resultStr), that.getReportByBarCode()
            }
          })
        })
    },
    async getInstitutionLocation() {
      let res = await institutionLocation(this.params)
      if (res) {
        this.hospitalsInfo.is_bar_code = res.is_bar_code
        this.hospitalsInfo.name = res.name
        this.hospitalsInfo.id = res.id
        this.hospitalsInfo.search = res.search
        this.placeholder = res.condition
        this.filmQueryLoading = false
        if (!this.hospitalsInfo.name) {
          alert('未定位到附近医院,请先选择就诊医院')
          this.$router.push({
            path: '/findHospital'
          })
        }
      }
    },
    async getReportByBarCode() {
      let res = await getReportByBarCode({
        bar_code: this.bar_code,
        institution_id: this.hospitalsInfo.id,
        phone: Storage.get('phone')
      })
      if (res) {
        //pay:1-已支付;2-未支付
        if (res.pay == 2) {
          this.$router.push({ path: '/reportList' })
        } else {
          if (res.code == 2) {
            if (res.examStatus == 1) {
              // code: 1-存在报告；2-不存在报告
              // examStatus: 1-不存在检查; 2-存在检查
              Storage.set('reportInfo', res.info)
              Storage.set('studyId', res.info[0].study_id)
              Storage.set('code', res.code)
              Storage.set('examStatus', res.examStatus)
              this.$router.push({ path: '/reportInfo/portrait' })
            } else if (res.examStatus == 2) {
              this.$router.push({ path: '/reportUnfinished' })
            }
          } else {
            Storage.set('code', res.code)
            Storage.set('examStatus', res.examStatus)
            Storage.set('reportInfo', res.info)
            Storage.set('studyId', res.info[0].study_id)
            this.$router.push({ path: '/reportInfo/report' })
          }
        }
      }
    },
    async getInsName(id) {
      let params = { institution_id: id }
      let res = await getInsName(params)
      if (res) {
        this.hospitalsInfo.is_bar_code = res.is_bar_code
        this.hospitalsInfo.name = res.name
        this.hospitalsInfo.id = res.id
        this.hospitalsInfo.search = res.search
        this.placeholder = res.condition
      }
    },
    async getFuzzyReportInfo(params) {
      let res = await fuzzyReportInfo(params)
      if (res) {
        if (res.pay == 2) {
          this.$router.push({ path: '/reportList' })
        } else {
          if (res.report_see == 0) {
            if (res.info[0].exam_status < 7) {//不存在检查
              this.$router.push({ path: '/reportUnfinished' })
              return
            } else {
              Storage.set('code', res.code)
              Storage.set('examStatus', res.examStatus)
              Storage.set('reportInfo', res.info)
              Storage.set('studyId', res.info[0].study_id)
              this.$router.push({ path: '/reportInfo/report' })
            }
          } else {
            Storage.set('code', res.code)
            Storage.set('examStatus', res.examStatus)
            Storage.set('reportInfo', res.info)
            Storage.set('studyId', res.info[0].study_id)
            this.$router.push({ path: '/reportInfo/report' })
          }
        }
      }
    },
    async getReportInfo(params) {
      const textValue = `<div style="white-space:normal;">
                            <div style="font-weight: 500">未查询到检查！可能由以下原因导致:</div>
                            <ol style="list-style: decimal;margin-left: 15px;"><li>您在医院就诊时预留了错误的手机号、身份证号等个人信息，请至医院窗口处修改</li><li>您输入错误了身份证号、姓名、就诊卡、门诊/住院号、病历号等信息，您可以通过添加绑定重新绑定查询</li>
                              <li>您使用了非就诊预留的手机号注册本服务，您可以通过注销后重新注册的方式更换绑定的手机号</li><li>您的检查未完成或正在上传，请耐心等待</li></ol>
                          </div>`
      const textValue06300009 = `<div style="white-space:normal;">
                            <div style="font-weight: 500">未查询到检查！可能由以下原因导致：</div>
                            <ol style="list-style: decimal;margin-left: 15px;"><li>1. 您在医院就诊时预留手机号、身份证号等个人信息有误，请至医院窗口处修改</li><li>2. 您输入的姓名、身份证号、手机号、就诊卡、门诊/住院号、病历号等信息有误，您可以通过“个人中心-添加绑定”重新查询尝试</li>
                              <li>3.你的检查未完成或正在上传，请耐心等待</li><</ol>
                          </div>`                      
      let res = await reportInfo(params)
      if (res) {
        // charge_mode收费模式  
        // 1.向患者结算（ 患者支付）
        // 2.向医院结算（医院托管）
        // 3.医院代收
        console.log(res.charge_mode, res.pay)
        if (res.charge_mode == 1 && res.pay == 2) {
          //向患者结算（ 患者支付）
          Dialog.confirm({
            title: '提示',
            message: '你输入的查询订单未支付，请支付后查看',
            confirmButtonText: '去支付'
          })
            .then(() => {
              this.$router.push({
                name: 'reportList',
                params: { isSure: true, exam_id: res.exam_id, institution_id: params.institution_id }
              })
            })
            .catch(() => {
              this.$router.push({
                name: 'reportList',
                params: { isSure: false }
              })
            })
        } else if (res.charge_mode == 3 && res.pay == 2) {
          //医院代收
          this.$router.push({
            name: 'reportList',
            params: { charge_mode: true, institution_id: params.institution_id }
          })
        } else {
          //report_see 报告未写之前公众号是否能查看影像
          // 1 可以查看  -----可以转发报告页面
          // 0 不可以查看 直接跳到报告列表
          //已经支付 pay 1
          if (res.report_see == 0) {
            if (res.info[0].exam_status < 7) {//不存在检查
              this.$router.push({ path: '/reportUnfinished' })
              return
            } else {
              if(res.info.length>0){
                Storage.set('code', res.code)
                Storage.set('examStatus', res.examStatus)
                Storage.set('reportInfo', res.info)
                Storage.set('studyId', res.info[0].study_id)
                this.$router.push({ path: '/reportInfo/report' })
              }else if(res.info.length === 0 && res.code === 2 && params.institution_id !== '06300009' && params.institution_id !== '06300006'){
                Dialog.confirm({
                  title: '提示',
                  messageAlign: 'left',
                  showCancelButton: false,
                  confirmButtonText:'我知道了',
                  message: params.institution_id === '06300009' ? textValue06300009 : textValue,
                })
                // check_phone 1校验 0正常
              }else if(res.info.length === 0 && res.code === 2 && (params.institution_id === '06300009' || params.institution_id === '06300006')){
                // 唐山工人和 唐山二院
                this.$router.push({
                  path: '/verifyPhone',
                  query: {
                    ...params,
                    phone: res.phone,
                    exam_id: res.exam_id
                  }
                })
              }
            }
          } else {
            if(res.info.length>0){
              Storage.set('code', res.code)
              Storage.set('examStatus', res.examStatus)
              Storage.set('reportInfo', res.info)
              Storage.set('studyId', res.info[0].study_id)
              this.$router.push({ path: '/reportInfo/report' })
            }else if(res.info.length === 0 && res.code === 2 && params.institution_id !== '06300009' && params.institution_id !== '06300006' ){
              Dialog.confirm({
                  title: '提示',
                  messageAlign: 'left',
                  showCancelButton: false,
                  confirmButtonText:'我知道了',
                  message: params.institution_id === '06300009' ? textValue06300009 : textValue,
                })
            }else if(res.info.length === 0 && res.code === 2 && (params.institution_id === '06300009' || params.institution_id === '06300006')){
              this.$router.push({
                path: '/verifyPhone',
                query: {
                  ...params,
                  phone: res.phone,
                  exam_id: res.exam_id
                }
              })
            }
            
          }
        }
      }
    },
    checkInf() {
      this.$router.push({
        path: '/checkInfo'
      })
    },
    logoutFn() {
      Dialog.confirm({
        title: '提示',
        message: '注销后将删除您账号下所有绑定的检查和用户信息，且不可恢复，您仍可以通过再次注册获取这些信息，您是否确认注销',
      }).then(() => {
        let res = logout({
          phone: Storage.get('phone')
        })
        if(res){
          Notify({ type: 'success', message: '注销成功', duration: 3000, })
          this.$router.push({
            path: '/'
          })
        }
        
      }).catch(() => {
        console.log('取消')
      })
    }
  },
  mounted() {
    if (this.$route.query.id == null && this.$route.query.value == null) {
      this.wxSDK()
    } else if (
      this.$route.query.id != null &&
      this.$route.query.value != null
    ) {
      this.hospitalsInfo.name = this.$route.query.value
      this.hospitalsInfo.id = this.$route.query.id
      this.hospitalsInfo.search = this.$route.query.search
      this.placeholder = this.$route.query.placeholder
      this.hospitalsInfo.is_bar_code = this.$route.query.is_bar_code
      this.filmQueryLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.pageContent {
  position: relative;
}
.perfectData {
  z-index: 9999;
  position: absolute;
  bottom: 2%;
  left: 5%;
}
.perfectData img {
  width: 30px;
  height: 30px;
}
.perfectData p {
  margin-top: 0px;
}
</style>
